module.exports = __webpack_public_path__ + "img/AIenginer.3e0f0e6.png";